/** Simple stroke icons for workspace navigation (decorative; buttons carry text labels). */
const PATHS: Record<string, string> = {
  playground: "M3 5h18v14H3zM8 5v9M13 5v9M18 5v9M6 14h4M11 14h4M16 14h4", // keyboard
  studio: "M3 4h4v4H3zM10 4h4v4h-4zM17 4h4v4h-4zM3 11h4v4H3zM17 11h4v4h-4zM10 18h4v3h-4zM3 18h4v3H3z", // step grid
  learn: "M2 9l10-5 10 5-10 5zM6 11v5c3 2 9 2 12 0v-5M22 9v6", // mortarboard
  band: "M12 3a3 3 0 0 1 3 3v5a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3zM6 11a6 6 0 0 0 12 0M12 17v4M8 21h8", // microphone
  gear: "M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0M16 4v4M10 10v4M18 16v4", // sliders
  projects: "M3 6h7l2 2h9v11H3z", // folder
};

export function NavIcon({ name }: { name: string }) {
  return (
    <svg className="nav-icon" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"
      fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d={PATHS[name] ?? ""} />
    </svg>
  );
}
